import w from "@arcgis/core/layers/FeatureLayer";
import g from "@arcgis/core/Graphic";
import E from "@arcgis/core/request";
import { createLogger as G } from "@origo/logger";
import re from "@arcgis/core/geometry/Point";
import te from "@arcgis/core/geometry/Polygon";
import { z as u } from "zod";
import { jsx as ae } from "react/jsx-runtime";
import { createContext as oe, useContext as Q } from "react";
import { useQuery as v, useQueryClient as y, useMutation as b } from "@tanstack/react-query";
class F extends Error {
  constructor(n, r) {
    super(n, r), this.name = "PlanregisterError";
  }
}
class I extends F {
  constructor(n, r) {
    super(`${n} not found: ${r}`), this.name = "NotFoundError";
  }
}
class P extends F {
  constructor(n, r) {
    super(n, { cause: r }), this.name = "ValidationError";
  }
}
class h extends F {
  constructor(n, r) {
    super(n, { cause: r }), this.name = "NetworkError";
  }
}
class se extends F {
  constructor(n = "Unauthorized") {
    super(n), this.name = "AuthError";
  }
}
class H extends F {
  constructor() {
    super("Operation was aborted"), this.name = "AbortedError";
  }
}
const z = "1";
function _(e) {
  return e.trim().padStart(4, "0");
}
function Y(e, n) {
  return `${_(e)}_${n.trim()}`;
}
const Z = [
  "plantype",
  "planstatus",
  "lovreferanse",
  "forslagsstillerType"
];
function le(e, n, r) {
  return r == null || r === "" ? "" : e?.[n]?.find((l) => l.code === r)?.label ?? r;
}
function ie(e, n) {
  return e?.[n] ?? [];
}
const W = [
  "planbehandlingtype"
], Yn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedError: H,
  AuthError: se,
  CODELIST_FIELDS: Z,
  DEFAULT_PLANSTATUS: z,
  NetworkError: h,
  NotFoundError: I,
  PLANBEHANDLING_CODELIST_FIELDS: W,
  PlanregisterError: F,
  ValidationError: P,
  deriveNasjonalArealplanId: Y,
  domainLabel: le,
  domainOptions: ie,
  normalizeAdmomrkode: _
}, Symbol.toStringTag, { value: "Module" }));
function T(e) {
  if (e != null)
    return new Date(e);
}
function R(e) {
  return !!e;
}
function de(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    nasjonalArealplanId: e.nasjonalArealplanId,
    admomrkode: e.admomrkode,
    planId: e.planId,
    plannavn: e.plannavn,
    plantype: e.plantype,
    planstatus: e.planstatus,
    lovreferanse: e.lovreferanse,
    saksnummer: e.saksnummer ?? "",
    saksaar: e.saksaar,
    sakssekvensnr: e.sakssekvensnr,
    forslagsstillerType: e.forslagsstillerType,
    ubehandletKlage: R(e.ubehandletKlage),
    ubehandletInnsigelse: R(e.ubehandletInnsigelse),
    vedtaksdato: T(e.vedtaksdato),
    vedtakEndeligPlanDato: T(e.vedtakEndeligPlanDato),
    ikrafttredelsesdato: T(e.ikrafttredelsesdato),
    kunngjoringsdato: T(e.kunngjoringsdato),
    opprinneligAdmomrKode: e.opprinneligAdmomrKode,
    opprinneligPlanId: e.opprinneligPlanId,
    planbestemmelser: R(e.planbestemmelser)
  };
}
function O(e) {
  return {
    nasjonalArealplanId: e.nasjonalArealplanId,
    admomrkode: e.admomrkode,
    planId: e.planId,
    plannavn: e.plannavn,
    plantype: e.plantype,
    planstatus: e.planstatus,
    lovreferanse: e.lovreferanse,
    saksnummer: e.saksnummer,
    saksaar: e.saksaar ?? null,
    sakssekvensnr: e.sakssekvensnr ?? null,
    forslagsstillerType: e.forslagsstillerType ?? null,
    ubehandletKlage: e.ubehandletKlage ? 1 : 0,
    ubehandletInnsigelse: e.ubehandletInnsigelse ? 1 : 0,
    vedtaksdato: e.vedtaksdato?.getTime() ?? null,
    vedtakEndeligPlanDato: e.vedtakEndeligPlanDato?.getTime() ?? null,
    ikrafttredelsesdato: e.ikrafttredelsesdato?.getTime() ?? null,
    kunngjoringsdato: e.kunngjoringsdato?.getTime() ?? null,
    opprinneligAdmomrKode: e.opprinneligAdmomrKode ?? null,
    opprinneligPlanId: e.opprinneligPlanId ?? null,
    planbestemmelser: e.planbestemmelser ? 1 : 0
  };
}
function Zn(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...O(e)
  };
}
function ue(e) {
  const n = e;
  return n && n.type === "coded-value" && Array.isArray(n.codedValues) ? n.codedValues : null;
}
function X(e, n) {
  const r = new Map(e.map((l) => [l.name, l])), a = {};
  for (const l of n) {
    const d = ue(r.get(l)?.domain);
    a[l] = d ? d.map((t) => ({ code: String(t.code), label: t.name })) : [];
  }
  return a;
}
function ce(e) {
  return X(e, Z);
}
function pe(e) {
  return e.replace(/'/g, "''");
}
function k(e) {
  return `'${pe(e)}'`;
}
function Wn(e, n) {
  return n.length === 0 ? "1=0" : `${e} IN (${n.map(k).join(",")})`;
}
const me = G("planregister:queryTablePaged"), fe = 2e3, ge = 1e3;
async function L(e, n, r) {
  const a = {
    where: n.where,
    outFields: n.outFields ? n.outFields.join(",") : "*",
    returnGeometry: n.returnGeometry === !0,
    f: "json"
  };
  n.orderByFields && (a.orderByFields = n.orderByFields);
  const l = [];
  let d = 0;
  try {
    for (let t = 0; t < ge; t++) {
      const s = (await E(`${e}/query`, {
        query: { ...a, resultOffset: d, resultRecordCount: fe },
        method: "post",
        responseType: "json",
        signal: r?.signal
      })).data, i = s?.features ?? [];
      for (const m of i)
        l.push(
          m.geometry ? { attributes: m.attributes, geometry: { ...m.geometry, spatialReference: s.spatialReference } } : { attributes: m.attributes }
        );
      if (s?.exceededTransferLimit !== !0 || i.length === 0)
        break;
      d += i.length;
    }
  } catch (t) {
    throw r?.signal?.aborted || ye(t) ? new H() : (me.error(`Feil ved query mot ${e}:`, t), new h(`Query mot ${e} feilet: ${t?.message ?? t}`, t));
  }
  return l;
}
async function D(e, n, r) {
  return (await L(e, n, r)).map((l) => l.attributes);
}
function ye(e) {
  return typeof e != "object" || e === null ? !1 : e.name === "AbortError";
}
function be(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await D(e, { where: t }, o)).map(de);
  return {
    findAll: (t) => d("1=1", t),
    findByNapId: async (t, o) => (await d(`nasjonalArealplanId = ${k(t)}`, o))[0] ?? null,
    search: (t, o) => {
      const s = k(`%${t}%`);
      return d(
        `LOWER(plannavn) LIKE LOWER(${s}) OR nasjonalArealplanId LIKE ${s} OR planId LIKE ${s}`,
        o
      );
    },
    add: async (t) => l(async () => {
      const o = new g({ attributes: O(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("Arealplan", m);
      return f[0];
    }, "ArealplanRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t.objectId, ...O(t) } }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("Arealplan", t.objectId);
      return i[0];
    }, "ArealplanRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "ArealplanRepository.delete"),
    getDomains: () => l(async () => {
      const t = a();
      return await t.load(), ce(t.fields);
    }, "ArealplanRepository.getDomains")
  };
}
function q(e) {
  if (e != null)
    return new Date(e);
}
function he(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    planbehUid: e.planbehUid,
    nasjonalArealplanId: e.nasjonalArealplanId,
    navn: e.navn,
    planbehandlingtype: e.planbehandlingtype,
    dato: q(e.dato),
    fradato: q(e.fradato),
    tildato: q(e.tildato),
    saksnummer: e.saksnummer,
    beskrivelse: e.beskrivelse
  };
}
function S(e) {
  return {
    planbehUid: e.planbehUid,
    nasjonalArealplanId: e.nasjonalArealplanId,
    navn: e.navn,
    planbehandlingtype: e.planbehandlingtype,
    dato: e.dato?.getTime() ?? null,
    fradato: e.fradato?.getTime() ?? null,
    tildato: e.tildato?.getTime() ?? null,
    saksnummer: e.saksnummer ?? null,
    beskrivelse: e.beskrivelse ?? null
  };
}
function Xn(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...S(e)
  };
}
function ke(e) {
  return X(e, W);
}
function Ie(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await D(e, { where: t }, o)).map(he);
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanId = ${k(t)}`, o),
    findByUid: async (t, o) => (await d(`planbehUid = ${k(t)}`, o))[0] ?? null,
    add: async (t) => l(async () => {
      const o = new g({ attributes: S(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("Planbehandling", m);
      return f[0];
    }, "PlanbehandlingRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t.objectId, ...S(t) } }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("Planbehandling", t.objectId);
      return i[0];
    }, "PlanbehandlingRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "PlanbehandlingRepository.delete"),
    getDomains: () => l(async () => {
      const t = a();
      return await t.load(), ke(t.fields);
    }, "PlanbehandlingRepository.getDomains")
  };
}
function ve(e) {
  if (e != null)
    return new Date(e);
}
function je(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    dokumentId: e.dokumentId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    planbehUid: e.planbehUid,
    dispensasjonId: e.dispensasjonId,
    tittel: e.tittel,
    dokumenttype: e.dokumenttype,
    dokumentstatus: e.dokumentstatus,
    arkivreferanse: e.arkivreferanse,
    arkivnavn: e.arkivnavn,
    dokumentdato: ve(e.dokumentdato),
    saksnummer: e.saksnummer,
    mimetype: e.mimetype,
    referansedokumentfil: e.referansedokumentfil,
    filnavn: e.filnavn,
    beskrivelse: e.beskrivelse
  };
}
function we(e) {
  return {
    dokumentId: e.dokumentId,
    nasjonalArealplanId: e.nasjonalArealplanId ?? null,
    planbehUid: e.planbehUid ?? null,
    dispensasjonId: e.dispensasjonId ?? null,
    tittel: e.tittel,
    dokumenttype: e.dokumenttype ?? null,
    dokumentstatus: e.dokumentstatus ?? null,
    arkivreferanse: e.arkivreferanse ?? null,
    arkivnavn: e.arkivnavn ?? null,
    dokumentdato: e.dokumentdato?.getTime() ?? null,
    saksnummer: e.saksnummer ?? null,
    mimetype: e.mimetype ?? null,
    referansedokumentfil: e.referansedokumentfil ?? null,
    filnavn: e.filnavn ?? null,
    beskrivelse: e.beskrivelse ?? null
  };
}
async function Ae(e, n, r) {
  const a = new FormData();
  a.append("attachment", r, r.name), a.append("f", "json");
  let l;
  try {
    l = await E(`${e}/${n}/addAttachment`, {
      method: "post",
      body: a,
      responseType: "json"
    });
  } catch (t) {
    throw new h(`Opplasting av vedlegg feilet: ${t?.message ?? t}`, t);
  }
  const d = l.data;
  if (d.error)
    throw new h(`Opplasting av vedlegg feilet: ${d.error.message}`);
  if (!d.addAttachmentResult?.success)
    throw new h("Opplasting av vedlegg feilet");
  return {
    path: `/${n}/attachments/${d.addAttachmentResult.objectId}`,
    filnavn: r.name,
    mimetype: r.type
  };
}
async function Fe(e, n) {
  let r;
  try {
    r = await E(`${e}/${n}/attachments`, {
      query: { f: "json" },
      responseType: "json"
    });
  } catch (l) {
    throw new h(`Henting av vedlegg feilet: ${l?.message ?? l}`, l);
  }
  const a = r.data;
  if (a.error)
    throw new h(`Henting av vedlegg feilet: ${a.error.message}`);
  return (a.attachmentInfos ?? []).map((l) => l.id);
}
async function Pe(e, n) {
  const r = await Fe(e, n);
  if (r.length === 0)
    return;
  let a;
  try {
    a = await E(`${e}/${n}/deleteAttachments`, {
      query: { attachmentIds: r.join(","), f: "json" },
      method: "post",
      responseType: "json"
    });
  } catch (t) {
    throw new h(`Sletting av vedlegg feilet: ${t?.message ?? t}`, t);
  }
  const l = a.data;
  if (l.error)
    throw new h(`Sletting av vedlegg feilet: ${l.error.message}`);
  const d = l.deleteAttachmentResults?.find((t) => !t.success);
  if (d)
    throw new h(`Sletting av vedlegg feilet: ${d.error?.description ?? "ukjent feil"}`);
}
async function Ee(e, n) {
  try {
    const r = n.startsWith("/") ? `${e}${n}` : n, a = await E(r, { responseType: "blob" });
    return URL.createObjectURL(a.data);
  } catch {
    return null;
  }
}
const De = G("planregister:plandokumentRepository");
function Te(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await D(e, { where: t }, o)).map(je);
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanId = ${k(t)}`, o),
    findForBehandling: (t, o) => d(`planbehUid = ${k(t)}`, o),
    findForDispensasjon: (t, o) => d(`dispensasjonId = ${k(t)}`, o),
    add: async (t, o) => l(async () => {
      const s = new g({ attributes: we(t) }), m = (await a().applyEdits({ addFeatures: [s] })).addFeatureResults[0];
      if (m.error)
        throw new Error(m.error.message);
      const f = m.objectId;
      if (o) {
        const $ = await Ae(e, f, o), ne = new g({
          attributes: {
            OBJECTID: f,
            referansedokumentfil: $.path,
            filnavn: $.filnavn,
            mimetype: $.mimetype
          }
        });
        await a().applyEdits({ updateFeatures: [ne] });
      }
      const x = await d(`OBJECTID = ${f}`);
      if (!x[0])
        throw new I("Plandokument", f);
      return x[0];
    }, "PlandokumentRepository.add"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
      try {
        await Pe(e, t);
      } catch (s) {
        De.warn(`Opprydding av vedlegg for plandokument ${t} feilet etter sletting`, s);
      }
    }, "PlandokumentRepository.delete"),
    fetchAttachmentBlobUrl: (t) => Ee(e, t)
  };
}
function Be(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    aktorId: e.aktorId,
    planbehUid: e.planbehUid,
    rolle: e.rolle,
    organisasjon: e.organisasjon,
    kontaktperson: e.kontaktperson
  };
}
function K(e) {
  return {
    aktorId: e.aktorId,
    planbehUid: e.planbehUid,
    rolle: e.rolle ?? null,
    organisasjon: e.organisasjon ?? null,
    kontaktperson: e.kontaktperson ?? null
  };
}
function er(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...K(e)
  };
}
function $e(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await D(e, { where: t }, o)).map(Be);
  return {
    findForBehandling: (t, o) => d(`planbehUid = ${k(t)}`, o),
    add: async (t) => l(async () => {
      const o = new g({ attributes: K(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("Aktor", m);
      return f[0];
    }, "AktorRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t.objectId, ...K(t) } }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("Aktor", t.objectId);
      return i[0];
    }, "AktorRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "AktorRepository.delete")
  };
}
function Re(e) {
  if (e != null)
    return new Date(e);
}
function qe(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    relasjonId: e.relasjonId,
    nasjonalArealplanIdFra: e.nasjonalArealplanIdFra,
    nasjonalArealplanIdTil: e.nasjonalArealplanIdTil,
    forholdtype: e.forholdtype,
    vedtakEndeligPlanDato: Re(e.vedtakEndeligPlanDato),
    begrunnelse: e.begrunnelse
  };
}
function Oe(e) {
  return {
    relasjonId: e.relasjonId,
    nasjonalArealplanIdFra: e.nasjonalArealplanIdFra,
    nasjonalArealplanIdTil: e.nasjonalArealplanIdTil,
    forholdtype: e.forholdtype,
    vedtakEndeligPlanDato: e.vedtakEndeligPlanDato?.getTime() ?? null,
    begrunnelse: e.begrunnelse ?? null
  };
}
function Se(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await D(e, { where: t }, o)).map(qe);
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanIdFra = ${k(t)} OR nasjonalArealplanIdTil = ${k(t)}`, o),
    add: async (t) => l(async () => {
      const o = new g({ attributes: Oe(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("Planforhold", m);
      return f[0];
    }, "PlanforholdRepository.add"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "PlanforholdRepository.delete")
  };
}
function N(e) {
  if (e != null)
    return new Date(e);
}
function Ke(e, n) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    dispensasjonId: e.dispensasjonId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    kommunenummer: e.kommunenummer,
    planidentifikasjon: e.planidentifikasjon,
    dispensasjonType: e.dispensasjonType,
    dispensasjonFra: e.dispensasjonFra,
    begrunnelse: e.begrunnelse,
    vedtaksdato: new Date(e.vedtaksdato),
    vertikalnivaa: e.vertikalnivaa,
    beskrivelse: e.beskrivelse,
    innvilgetDispensasjon: !!e.innvilgetDispensasjon,
    varigDispensasjon: !!e.varigDispensasjon,
    varighetFra: N(e.varighetFra),
    varighetTil: N(e.varighetTil),
    sakssekvensnummer: e.saksnummer__sakssekvensnummer,
    saksaar: e.saksnummer__saksaar,
    geometry: n
  };
}
function U(e) {
  return {
    dispensasjonId: e.dispensasjonId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    kommunenummer: e.kommunenummer ?? null,
    planidentifikasjon: e.planidentifikasjon ?? null,
    dispensasjonType: e.dispensasjonType ?? null,
    dispensasjonFra: e.dispensasjonFra ?? null,
    begrunnelse: e.begrunnelse ?? null,
    vedtaksdato: e.vedtaksdato.getTime(),
    vertikalnivaa: e.vertikalnivaa ?? null,
    beskrivelse: e.beskrivelse ?? null,
    innvilgetDispensasjon: e.innvilgetDispensasjon ? 1 : 0,
    varigDispensasjon: e.varigDispensasjon ? 1 : 0,
    varighetFra: e.varighetFra?.getTime() ?? null,
    varighetTil: e.varighetTil?.getTime() ?? null,
    saksnummer__sakssekvensnummer: e.sakssekvensnummer ?? null,
    saksnummer__saksaar: e.saksaar ?? null
  };
}
function _e(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await L(e, { where: t, returnGeometry: !0 }, o)).map(
    (i) => Ke(i.attributes, i.geometry ? re.fromJSON(i.geometry) : void 0)
  );
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanId = ${k(t)}`, o),
    findByDispensasjonId: async (t, o) => (await d(`dispensasjonId = ${k(t)}`, o))[0] ?? null,
    add: async (t) => l(async () => {
      const o = new g({
        attributes: U(t),
        geometry: t.geometry
      }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("Dispensasjon", m);
      return f[0];
    }, "DispensasjonRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({
        attributes: { OBJECTID: t.objectId, ...U(t) },
        geometry: t.geometry
      }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("Dispensasjon", t.objectId);
      return i[0];
    }, "DispensasjonRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "DispensasjonRepository.delete")
  };
}
function J(e) {
  if (e != null)
    return new Date(e);
}
function Le(e, n) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    forbudId: e.forbudId,
    kommunenummer: e.kommunenummer,
    forbudtype: e.forbudtype,
    omraadenavn: e.omraadenavn,
    avgjdato: J(e.avgjdato),
    gyldigtildato: J(e.gyldigtildato),
    sakssekvensnummer: e.saksnummer__sakssekvensnummer,
    saksaar: e.saksnummer__saksaar,
    informasjon: e.informasjon,
    geometry: n
  };
}
function M(e) {
  return {
    forbudId: e.forbudId,
    kommunenummer: e.kommunenummer ?? null,
    forbudtype: e.forbudtype,
    omraadenavn: e.omraadenavn ?? null,
    avgjdato: e.avgjdato?.getTime() ?? null,
    gyldigtildato: e.gyldigtildato?.getTime() ?? null,
    saksnummer__sakssekvensnummer: e.sakssekvensnummer ?? null,
    saksnummer__saksaar: e.saksaar ?? null,
    informasjon: e.informasjon ?? null
  };
}
function Ce(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new h(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await L(e, { where: t, returnGeometry: !0 }, o)).map(
    (i) => Le(i.attributes, i.geometry ? te.fromJSON(i.geometry) : void 0)
  );
  return {
    findForKommune: (t, o) => d(`kommunenummer = ${k(t)}`, o),
    findByForbudId: async (t, o) => (await d(`forbudId = ${k(t)}`, o))[0] ?? null,
    add: async (t) => l(async () => {
      const o = new g({
        attributes: M(t),
        geometry: t.geometry
      }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("MidlertidigForbud", m);
      return f[0];
    }, "MidlertidigForbudRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({
        attributes: { OBJECTID: t.objectId, ...M(t) },
        geometry: t.geometry
      }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("MidlertidigForbud", t.objectId);
      return i[0];
    }, "MidlertidigForbudRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "MidlertidigForbudRepository.delete")
  };
}
const xe = 0, Ne = 1, Ue = 2, Je = 3, Me = 4, Ve = 5, Ge = 6;
function nr(e) {
  const n = e.serviceUrl.replace(/\/$/, ""), r = (l) => `${n}/${l}`, { getToken: a } = e;
  return {
    arealplaner: be(r(Ue), a),
    behandlinger: Ie(r(Je), a),
    dokumenter: Te(r(Me), a),
    aktorer: $e(r(Ve), a),
    planforhold: Se(r(Ge), a),
    dispensasjoner: _e(r(xe), a),
    midlertidigeForbud: Ce(r(Ne), a)
  };
}
const c = {
  all: ["planregister"],
  arealplaner: {
    all: ["planregister", "arealplaner"],
    search: (e) => ["planregister", "arealplaner", "search", e],
    byNapId: (e) => ["planregister", "arealplaner", e],
    domains: ["planregister", "arealplaner", "domains"]
  },
  behandlinger: {
    all: ["planregister", "behandlinger"],
    forPlan: (e) => ["planregister", "behandlinger", e],
    byUid: (e) => ["planregister", "behandlinger", "uid", e],
    domains: ["planregister", "behandlinger", "domains"]
  },
  dokumenter: {
    all: ["planregister", "dokumenter"],
    forPlan: (e) => ["planregister", "dokumenter", "plan", e],
    forBehandling: (e) => ["planregister", "dokumenter", "behandling", e],
    forDispensasjon: (e) => ["planregister", "dokumenter", "dispensasjon", e]
  },
  aktorer: {
    all: ["planregister", "aktorer"],
    forBehandling: (e) => ["planregister", "aktorer", e]
  },
  planforhold: {
    all: ["planregister", "planforhold"],
    forPlan: (e) => ["planregister", "planforhold", e]
  },
  dispensasjoner: {
    all: ["planregister", "dispensasjoner"],
    forPlan: (e) => ["planregister", "dispensasjoner", e],
    byId: (e) => ["planregister", "dispensasjoner", "id", e]
  },
  midlertidigeForbud: {
    all: ["planregister", "midlertidigeForbud"],
    forKommune: (e) => ["planregister", "midlertidigeForbud", e],
    byId: (e) => ["planregister", "midlertidigeForbud", "id", e]
  }
}, Qe = ["10", "11", "13", "20", "21", "34", "35", "30", "31"], He = ["1", "2", "3", "4", "5", "6", "7", "8"], ze = ["PBL2008", "PBL1985", "BL1965"], Ye = ["1", "2", "3", "4", "9"], B = (e) => ({ errorMap: () => ({ message: e }) }), Ze = u.object({
  plannavn: u.string().trim().min(1, "Plannavn er påkrevd").max(250, "Plannavn er for langt"),
  plantype: u.enum(Qe, B("Velg en gyldig plantype")),
  planstatus: u.enum(He, B("Velg en gyldig planstatus")).optional(),
  lovreferanse: u.enum(ze, B("Velg en gyldig lovreferanse")),
  saksnummer: u.string().trim().min(1, "Saksnummer er påkrevd"),
  admomrkode: u.string().trim().min(1, "Kommunenummer er påkrevd").regex(/^\d{1,4}$/, "Kommunenummer må være inntil 4 siffer"),
  planId: u.string().trim().min(1, "PlanID er påkrevd"),
  saksaar: u.number().int().optional(),
  sakssekvensnr: u.number().int().optional(),
  forslagsstillerType: u.enum(Ye, B("Velg en gyldig forslagsstillertype")).optional(),
  ubehandletKlage: u.boolean().optional(),
  ubehandletInnsigelse: u.boolean().optional(),
  vedtaksdato: u.date().optional(),
  vedtakEndeligPlanDato: u.date().optional(),
  ikrafttredelsesdato: u.date().optional(),
  kunngjoringsdato: u.date().optional(),
  opprinneligAdmomrKode: u.string().trim().optional(),
  opprinneligPlanId: u.string().trim().optional(),
  planbestemmelser: u.boolean().optional()
}), We = u.object({
  planbehUid: u.string().trim().min(1, "planbehUid er påkrevd"),
  nasjonalArealplanId: u.string().trim().min(1, "nasjonalArealplanId er påkrevd"),
  navn: u.string().trim().min(1, "Navn er påkrevd").max(250, "Navn er for langt"),
  planbehandlingtype: u.string().trim().min(1, "Velg behandlingstype"),
  dato: u.date({ required_error: "Dato er påkrevd", invalid_type_error: "Ugyldig dato" }),
  fradato: u.date({ invalid_type_error: "Ugyldig dato" }).optional(),
  tildato: u.date({ invalid_type_error: "Ugyldig dato" }).optional(),
  saksnummer: u.string().trim().max(50, "Saksnummer er for langt").optional(),
  beskrivelse: u.string().trim().max(2e3, "Beskrivelsen er for lang").optional()
}).superRefine((e, n) => {
  e.fradato && e.tildato && e.tildato < e.fradato && n.addIssue({
    code: u.ZodIssueCode.custom,
    path: ["tildato"],
    message: "Til-dato kan ikke være før fra-dato"
  });
}), Xe = u.object({
  nasjonalArealplanId: u.string().trim().min(1, "nasjonalArealplanId er påkrevd"),
  tittel: u.string().trim().min(1, "Tittel er påkrevd").max(250, "Tittel er for lang"),
  dokumenttype: u.string().trim().optional()
}), en = [
  "100",
  "110",
  "111",
  "120",
  "130",
  "140",
  "141",
  "142",
  "143",
  "150",
  "160",
  "161",
  "162",
  "163",
  "165",
  "170",
  "171",
  "172",
  "173",
  "174",
  "200",
  "300",
  "400",
  "500"
], nn = ["ARB", "PLAN", "TEK", "FORU", "JORD", "KOM", "PBL", "VEG"], V = (e) => ({ errorMap: () => ({ message: e }) }), rr = u.object({
  nasjonalArealplanId: u.string().trim().min(1, "nasjonalArealplanId er påkrevd"),
  dispensasjonType: u.enum(en, V("Velg en gyldig dispensasjonstype")).optional(),
  dispensasjonFra: u.enum(nn, V("Velg et gyldig lovverk")).optional(),
  vedtaksdato: u.date({ required_error: "Vedtaksdato er påkrevd", invalid_type_error: "Vedtaksdato er påkrevd" }),
  innvilgetDispensasjon: u.boolean(),
  varigDispensasjon: u.boolean(),
  varighetFra: u.date().optional(),
  varighetTil: u.date().optional(),
  saksaar: u.number().int().optional(),
  sakssekvensnummer: u.number().int().optional(),
  begrunnelse: u.string().trim().max(2e3, "Begrunnelse er for lang").optional(),
  beskrivelse: u.string().trim().max(2e3, "Beskrivelse er for lang").optional()
}).superRefine((e, n) => {
  !e.varigDispensasjon && e.varighetFra === void 0 && n.addIssue({
    code: u.ZodIssueCode.custom,
    path: ["varighetFra"],
    message: "Varighet fra er påkrevd når dispensasjonen ikke er varig"
  }), !e.varigDispensasjon && e.varighetTil === void 0 && n.addIssue({
    code: u.ZodIssueCode.custom,
    path: ["varighetTil"],
    message: "Varighet til er påkrevd når dispensasjonen ikke er varig"
  });
}).refine(
  (e) => !e.varighetFra || !e.varighetTil || e.varighetTil > e.varighetFra,
  { message: "Varighet til må være etter varighet fra", path: ["varighetTil"] }
);
async function rn(e, n) {
  return e.arealplaner.findAll(n);
}
async function tn(e, n, r) {
  return e.arealplaner.findByNapId(n, r);
}
async function an(e, n, r) {
  return e.arealplaner.search(n, r);
}
async function on(e, n, r) {
  const a = Ze.safeParse(n);
  if (!a.success) {
    const { message: i, path: m } = a.error.issues[0], f = m.join(".");
    throw new P(f ? `${f}: ${i}` : i, a.error);
  }
  const l = a.data, d = _(l.admomrkode), t = Y(d, l.planId);
  if (await e.arealplaner.findByNapId(t, r))
    throw new P(
      `Plan-ID «${l.planId.trim()}» finnes allerede i kommune ${d} (${t}).`
    );
  const s = {
    ...l,
    admomrkode: d,
    planId: l.planId.trim(),
    nasjonalArealplanId: t,
    planstatus: l.planstatus ?? z,
    ubehandletKlage: l.ubehandletKlage ?? !1,
    ubehandletInnsigelse: l.ubehandletInnsigelse ?? !1,
    planbestemmelser: l.planbestemmelser ?? !1
  };
  return e.arealplaner.add(s);
}
async function sn(e, n) {
  return e.arealplaner.getDomains(n);
}
async function ln(e, n) {
  return e.arealplaner.update(n);
}
async function dn(e, n) {
  return e.arealplaner.delete(n);
}
async function un(e, n) {
  return e.behandlinger.getDomains(n);
}
async function cn(e, n, r) {
  return e.behandlinger.findForPlan(n, r);
}
async function tr(e, n, r) {
  return e.behandlinger.findByUid(n, r);
}
function ee(e) {
  const n = We.safeParse(e);
  if (!n.success) {
    const { message: a, path: l } = n.error.issues[0], d = l.join(".");
    throw new P(d ? `${d}: ${a}` : a, n.error);
  }
  const r = n.data;
  return {
    ...r,
    saksnummer: r.saksnummer || void 0,
    beskrivelse: r.beskrivelse || void 0
  };
}
async function pn(e, n) {
  return e.behandlinger.add(ee(n));
}
async function mn(e, n) {
  const { objectId: r, globalId: a, ...l } = n;
  return e.behandlinger.update({ objectId: r, globalId: a, ...ee(l) });
}
async function fn(e, n) {
  return e.behandlinger.delete(n);
}
function gn(e) {
  const n = Xe.safeParse(e);
  if (!n.success) {
    const { message: r, path: a } = n.error.issues[0], l = a.join(".");
    throw new P(l ? `${l}: ${r}` : r, n.error);
  }
  return e;
}
async function yn(e, n, r) {
  return e.dokumenter.findForPlan(n, r);
}
async function bn(e, n, r) {
  return e.dokumenter.findForBehandling(n, r);
}
async function hn(e, n, r) {
  return e.dokumenter.findForDispensasjon(n, r);
}
async function kn(e, n, r) {
  return e.dokumenter.add(gn(n), r);
}
async function In(e, n) {
  return e.dokumenter.fetchAttachmentBlobUrl(n);
}
async function vn(e, n) {
  return e.dokumenter.delete(n);
}
async function jn(e, n, r) {
  return e.aktorer.findForBehandling(n, r);
}
async function wn(e, n) {
  return e.aktorer.add(n);
}
async function An(e, n) {
  return e.aktorer.update(n);
}
async function Fn(e, n) {
  return e.aktorer.delete(n);
}
async function Pn(e, n, r) {
  return e.planforhold.findForPlan(n, r);
}
async function En(e, n) {
  return e.planforhold.add(n);
}
async function Dn(e, n) {
  return e.planforhold.delete(n);
}
async function Tn(e, n, r) {
  return e.dispensasjoner.findForPlan(n, r);
}
async function ar(e, n, r) {
  return e.dispensasjoner.findByDispensasjonId(n, r);
}
async function Bn(e, n) {
  return e.dispensasjoner.add(n);
}
async function $n(e, n) {
  return e.dispensasjoner.update(n);
}
async function Rn(e, n) {
  return e.dispensasjoner.delete(n);
}
async function qn(e, n, r) {
  return e.midlertidigeForbud.findForKommune(n, r);
}
async function or(e, n, r) {
  return e.midlertidigeForbud.findByForbudId(n, r);
}
async function On(e, n) {
  return e.midlertidigeForbud.add(n);
}
async function Sn(e, n) {
  return e.midlertidigeForbud.update(n);
}
async function Kn(e, n) {
  return e.midlertidigeForbud.delete(n);
}
const C = oe(null);
function sr({ client: e, children: n }) {
  return /* @__PURE__ */ ae(C.Provider, { value: e, children: n });
}
function p() {
  const e = Q(C);
  if (!e)
    throw new Error("usePlanregisterClient must be used inside <PlanregisterClientProvider>");
  return e;
}
function lr() {
  return Q(C);
}
function ir() {
  const e = p();
  return v({
    queryKey: c.arealplaner.all,
    queryFn: ({ signal: n }) => rn(e, { signal: n })
  });
}
function dr(e) {
  const n = p();
  return v({
    queryKey: c.arealplaner.search(e),
    queryFn: ({ signal: r }) => an(n, e, { signal: r }),
    enabled: e.length > 0
  });
}
function ur(e) {
  const n = p();
  return v({
    queryKey: c.arealplaner.byNapId(e ?? ""),
    queryFn: ({ signal: r }) => tn(n, e, { signal: r }),
    enabled: !!e
  });
}
function cr() {
  const e = p();
  return v({
    queryKey: c.arealplaner.domains,
    queryFn: ({ signal: n }) => sn(e, { signal: n }),
    staleTime: 1 / 0
  });
}
function pr() {
  const e = p(), n = y();
  return b({
    mutationFn: (r) => on(e, r),
    onSuccess: () => n.invalidateQueries({ queryKey: c.arealplaner.all })
  });
}
function mr() {
  const e = p(), n = y();
  return b({
    mutationFn: (r) => ln(e, r),
    onSuccess: (r) => {
      n.invalidateQueries({ queryKey: c.arealplaner.all }), n.invalidateQueries({ queryKey: c.arealplaner.byNapId(r.nasjonalArealplanId) });
    }
  });
}
function fr() {
  const e = p(), n = y();
  return b({
    mutationFn: (r) => dn(e, r),
    onSuccess: () => n.invalidateQueries({ queryKey: c.arealplaner.all })
  });
}
function gr() {
  const e = p();
  return v({
    queryKey: c.behandlinger.domains,
    queryFn: ({ signal: n }) => un(e, { signal: n }),
    staleTime: 1 / 0
  });
}
function yr(e) {
  const n = p();
  return v({
    queryKey: c.behandlinger.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => cn(n, e, { signal: r }),
    enabled: !!e
  });
}
function br() {
  const e = p(), n = y();
  return b({
    mutationFn: (r) => pn(e, r),
    onSuccess: (r) => n.invalidateQueries({ queryKey: c.behandlinger.forPlan(r.nasjonalArealplanId) })
  });
}
function hr() {
  const e = p(), n = y();
  return b({
    mutationFn: (r) => mn(e, r),
    onSuccess: (r) => n.invalidateQueries({ queryKey: c.behandlinger.forPlan(r.nasjonalArealplanId) })
  });
}
function kr(e) {
  const n = p(), r = y();
  return b({
    mutationFn: (a) => fn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.behandlinger.forPlan(e) })
  });
}
function Ir(e) {
  const n = p();
  return v({
    queryKey: c.dokumenter.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => yn(n, e, { signal: r }),
    enabled: !!e
  });
}
function vr(e) {
  const n = p();
  return v({
    queryKey: c.dokumenter.forBehandling(e ?? ""),
    queryFn: ({ signal: r }) => bn(n, e, { signal: r }),
    enabled: !!e
  });
}
function jr(e) {
  const n = p();
  return v({
    queryKey: c.dokumenter.forDispensasjon(e ?? ""),
    queryFn: ({ signal: r }) => hn(n, e, { signal: r }),
    enabled: !!e
  });
}
function wr() {
  const e = p(), n = y();
  return b({
    mutationFn: (r) => kn(e, r.input, r.file),
    onSuccess: (r) => {
      r.nasjonalArealplanId && n.invalidateQueries({ queryKey: c.dokumenter.forPlan(r.nasjonalArealplanId) }), r.planbehUid && n.invalidateQueries({ queryKey: c.dokumenter.forBehandling(r.planbehUid) });
    }
  });
}
function Ar() {
  const e = p(), n = y();
  return b({
    mutationFn: (r) => vn(e, r),
    onSuccess: () => n.invalidateQueries({ queryKey: c.dokumenter.all })
  });
}
function Fr() {
  const e = p();
  return (n) => In(e, n);
}
function Pr(e) {
  const n = p();
  return v({
    queryKey: c.aktorer.forBehandling(e ?? ""),
    queryFn: ({ signal: r }) => jn(n, e, { signal: r }),
    enabled: !!e
  });
}
function Er(e) {
  const n = p(), r = y();
  return b({
    mutationFn: (a) => wn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.aktorer.forBehandling(e) })
  });
}
function Dr(e) {
  const n = p(), r = y();
  return b({
    mutationFn: (a) => An(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.aktorer.forBehandling(e) })
  });
}
function Tr(e) {
  const n = p(), r = y();
  return b({
    mutationFn: (a) => Fn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.aktorer.forBehandling(e) })
  });
}
function Br(e) {
  const n = p();
  return v({
    queryKey: c.planforhold.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => Pn(n, e, { signal: r }),
    enabled: !!e
  });
}
function $r(e) {
  const n = p(), r = y();
  return b({
    mutationFn: (a) => En(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.planforhold.forPlan(e) })
  });
}
function Rr(e) {
  const n = p(), r = y();
  return b({
    mutationFn: (a) => Dn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.planforhold.forPlan(e) })
  });
}
function qr(e) {
  const n = p();
  return v({
    queryKey: c.dispensasjoner.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => Tn(n, e, { signal: r }),
    enabled: !!e
  });
}
function Or(e) {
  const n = p(), r = y();
  return b({
    mutationFn: (a) => Bn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.dispensasjoner.forPlan(e) })
  });
}
function Sr(e) {
  const n = p(), r = y();
  return b({
    mutationFn: (a) => $n(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.dispensasjoner.forPlan(e) })
  });
}
function Kr(e) {
  const n = p(), r = y();
  return b({
    mutationFn: (a) => Rn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.dispensasjoner.forPlan(e) })
  });
}
function _r(e) {
  const n = p();
  return v({
    queryKey: c.midlertidigeForbud.forKommune(e ?? ""),
    queryFn: ({ signal: r }) => qn(n, e, { signal: r }),
    enabled: !!e
  });
}
function Lr(e) {
  const n = p(), r = y();
  return b({
    mutationFn: (a) => On(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.midlertidigeForbud.forKommune(e) })
  });
}
function Cr(e) {
  const n = p(), r = y();
  return b({
    mutationFn: (a) => Sn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.midlertidigeForbud.forKommune(e) })
  });
}
function xr(e) {
  const n = p(), r = y();
  return b({
    mutationFn: (a) => Kn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.midlertidigeForbud.forKommune(e) })
  });
}
const _n = {
  plantype: [
    { code: "10", label: "Fylkesplan" },
    { code: "11", label: "Fylkesdelplan" },
    { code: "13", label: "Regional plan" },
    { code: "20", label: "Kommuneplan" },
    { code: "21", label: "Kommunedelplan" },
    { code: "34", label: "Områderegulering" },
    { code: "35", label: "Detaljregulering" },
    { code: "30", label: "Reguleringsplan (pbl 1985)" },
    { code: "31", label: "Bebyggelsesplan (pbl 1985)" }
  ],
  planstatus: [
    { code: "1", label: "Planlegging igangsatt" },
    { code: "2", label: "Planforslag" },
    { code: "3", label: "Endelig vedtatt" },
    { code: "4", label: "Opphevet" },
    { code: "5", label: "Utgått/erstattet" },
    { code: "6", label: "Vedtatt med utsatt rettsvirkning" },
    { code: "7", label: "Endelig vedtatt med tidsbegrensning" },
    { code: "8", label: "Overstyrt" }
  ],
  lovreferanse: [
    { code: "PBL2008", label: "Plan- og bygningsloven 2008" },
    { code: "PBL1985", label: "Plan- og bygningsloven 1985" },
    { code: "BL1965", label: "Bygningsloven 1965" }
  ],
  forslagsstillerType: [
    { code: "1", label: "Kommunen" },
    { code: "2", label: "Statlig myndighet" },
    { code: "3", label: "Fylkeskommune" },
    { code: "4", label: "Privat forslagsstiller" },
    { code: "9", label: "Annen" }
  ]
}, Ln = {
  planbehandlingtype: [
    { code: "A", label: "Testbehandling A" },
    { code: "B", label: "Testbehandling B" },
    { code: "C", label: "Testbehandling C" }
  ]
};
let Cn = 1;
const j = () => Cn++, A = () => `{${j().toString().padStart(8, "0")}-0000-0000-0000-000000000000}`;
class Nr {
  constructor() {
    this.store = [];
  }
  findAll(n) {
    return Promise.resolve([...this.store]);
  }
  findByNapId(n, r) {
    return Promise.resolve(this.store.find((a) => a.nasjonalArealplanId === n) ?? null);
  }
  search(n, r) {
    const a = n.toLowerCase();
    return Promise.resolve(this.store.filter(
      (l) => l.plannavn?.toLowerCase().includes(a) || l.planId.includes(n) || l.nasjonalArealplanId.includes(n)
    ));
  }
  add(n) {
    const r = { ...n, objectId: j(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Arealplan ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  getDomains() {
    return Promise.resolve(_n);
  }
}
class Ur {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((a) => a.nasjonalArealplanId === n));
  }
  findByUid(n, r) {
    return Promise.resolve(this.store.find((a) => a.planbehUid === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: j(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Planbehandling ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  getDomains() {
    return Promise.resolve(Ln);
  }
}
class Jr {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((a) => a.nasjonalArealplanId === n));
  }
  findForBehandling(n, r) {
    return Promise.resolve(this.store.filter((a) => a.planbehUid === n));
  }
  findForDispensasjon(n, r) {
    return Promise.resolve(this.store.filter((a) => a.dispensasjonId === n));
  }
  add(n, r) {
    const a = {
      ...n,
      objectId: j(),
      globalId: A(),
      ...r ? { filnavn: r.name, mimetype: r.type, referansedokumentfil: `fake://${r.name}` } : {}
    };
    return this.store.push(a), Promise.resolve(a);
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  fetchAttachmentBlobUrl(n) {
    return Promise.resolve(`fake-blob://${n}`);
  }
}
class Mr {
  constructor() {
    this.store = [];
  }
  findForBehandling(n, r) {
    return Promise.resolve(this.store.filter((a) => a.planbehUid === n));
  }
  add(n) {
    const r = { ...n, objectId: j(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Aktor ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class Vr {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter(
      (a) => a.nasjonalArealplanIdFra === n || a.nasjonalArealplanIdTil === n
    ));
  }
  add(n) {
    const r = { ...n, objectId: j(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class Gr {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((a) => a.nasjonalArealplanId === n));
  }
  findByDispensasjonId(n, r) {
    return Promise.resolve(this.store.find((a) => a.dispensasjonId === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: j(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Dispensasjon ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class Qr {
  constructor() {
    this.store = [];
  }
  findForKommune(n, r) {
    return Promise.resolve(this.store.filter((a) => a.kommunenummer === n));
  }
  findByForbudId(n, r) {
    return Promise.resolve(this.store.find((a) => a.forbudId === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: j(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`MidlertidigForbud ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
export {
  H as AbortedError,
  se as AuthError,
  Z as CODELIST_FIELDS,
  z as DEFAULT_PLANSTATUS,
  nn as DISPENSASJONFRA_VALUES,
  en as DISPENSASJONSTYPE_VALUES,
  _n as FAKE_AREALPLAN_DOMAINS,
  Ln as FAKE_PLANBEHANDLING_DOMAINS,
  Ye as FORSLAGSSTILLER_VALUES,
  Mr as FakeAktorRepository,
  Nr as FakeArealplanRepository,
  Gr as FakeDispensasjonRepository,
  Qr as FakeMidlertidigForbudRepository,
  Ur as FakePlanbehandlingRepository,
  Jr as FakePlandokumentRepository,
  Vr as FakePlanforholdRepository,
  ze as LOVREFERANSE_VALUES,
  h as NetworkError,
  I as NotFoundError,
  W as PLANBEHANDLING_CODELIST_FIELDS,
  He as PLANSTATUS_VALUES,
  Qe as PLANTYPE_VALUES,
  sr as PlanregisterClientProvider,
  F as PlanregisterError,
  P as ValidationError,
  Be as aktorFromAttrs,
  K as aktorInputToAttrs,
  er as aktorToAttrs,
  de as arealplanFromAttrs,
  Ze as arealplanInputSchema,
  O as arealplanInputToAttrs,
  Zn as arealplanToAttrs,
  ce as buildArealplanDomains,
  X as buildDomains,
  Wn as buildInClause,
  ke as buildPlanbehandlingDomains,
  wn as createAktor,
  $e as createArcgisAktorRepository,
  be as createArcgisArealplanRepository,
  _e as createArcgisDispensasjonRepository,
  Ce as createArcgisMidlertidigForbudRepository,
  Ie as createArcgisPlanbehandlingRepository,
  Te as createArcgisPlandokumentRepository,
  Se as createArcgisPlanforholdRepository,
  on as createArealplan,
  Bn as createDispensasjon,
  On as createMidlertidigForbud,
  pn as createPlanbehandling,
  kn as createPlandokument,
  En as createPlanforhold,
  nr as createPlanregisterClient,
  Fn as deleteAktor,
  dn as deleteArealplan,
  Rn as deleteDispensasjon,
  Kn as deleteMidlertidigForbud,
  fn as deletePlanbehandling,
  vn as deletePlandokument,
  Dn as deletePlanforhold,
  Y as deriveNasjonalArealplanId,
  Ke as dispensasjonFromAttrs,
  rr as dispensasjonInputSchema,
  U as dispensasjonInputToAttrs,
  Yn as domain,
  le as domainLabel,
  ie as domainOptions,
  pe as escapeSqlValue,
  In as fetchPlandokumentAttachmentBlobUrl,
  rn as findAllArealplaner,
  tn as findArealplanByNapId,
  tr as findBehandlingByUid,
  ar as findDispensasjonById,
  or as findMidlertidigForbudById,
  jn as loadAktorerForBehandling,
  sn as loadArealplanDomains,
  cn as loadBehandlingerForPlan,
  Tn as loadDispensasjonerForPlan,
  bn as loadDokumenterForBehandling,
  hn as loadDokumenterForDispensasjon,
  yn as loadDokumenterForPlan,
  qn as loadMidlertidigForbudForKommune,
  un as loadPlanbehandlingDomains,
  Pn as loadPlanforholdForPlan,
  Le as midlertidigForbudFromAttrs,
  M as midlertidigForbudInputToAttrs,
  _ as normalizeAdmomrkode,
  he as planbehandlingFromAttrs,
  We as planbehandlingInputSchema,
  S as planbehandlingInputToAttrs,
  Xn as planbehandlingToAttrs,
  je as plandokumentFromAttrs,
  Xe as plandokumentInputSchema,
  we as plandokumentInputToAttrs,
  qe as planforholdFromAttrs,
  Oe as planforholdInputToAttrs,
  c as planregisterKeys,
  L as queryFeaturesPaged,
  D as queryTablePaged,
  k as qv,
  an as searchArealplaner,
  An as updateAktor,
  ln as updateArealplan,
  $n as updateDispensasjon,
  Sn as updateMidlertidigForbud,
  mn as updatePlanbehandling,
  Pr as useAktorer,
  ur as useArealplan,
  cr as useArealplanDomains,
  ir as useArealplaner,
  dr as useArealplanerSearch,
  Er as useCreateAktor,
  pr as useCreateArealplan,
  Or as useCreateDispensasjon,
  Lr as useCreateMidlertidigForbud,
  br as useCreatePlanbehandling,
  wr as useCreatePlandokument,
  $r as useCreatePlanforhold,
  Tr as useDeleteAktor,
  fr as useDeleteArealplan,
  Kr as useDeleteDispensasjon,
  xr as useDeleteMidlertidigForbud,
  kr as useDeletePlanbehandling,
  Ar as useDeletePlandokument,
  Rr as useDeletePlanforhold,
  qr as useDispensasjoner,
  Fr as useFetchPlandokumentAttachmentUrl,
  _r as useMidlertidigeForbud,
  gr as usePlanbehandlingDomains,
  yr as usePlanbehandlinger,
  vr as usePlandokumenterForBehandling,
  jr as usePlandokumenterForDispensasjon,
  Ir as usePlandokumenterForPlan,
  Br as usePlanforhold,
  p as usePlanregisterClient,
  lr as usePlanregisterClientOptional,
  Dr as useUpdateAktor,
  mr as useUpdateArealplan,
  Sr as useUpdateDispensasjon,
  Cr as useUpdateMidlertidigForbud,
  hr as useUpdatePlanbehandling
};
//# sourceMappingURL=index.mjs.map
